import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SendToSegmentAccountComponent } from './send-to-segment-account-popup/send-to-segment-account.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [SendToSegmentAccountComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule
  ],
  exports: [SendToSegmentAccountComponent]
})
export class SendToSegmentAccountModule { }
